import { render, staticRenderFns } from "./FooterConfig.vue?vue&type=template&id=ab073568"
import script from "./FooterConfig.vue?vue&type=script&lang=js"
export * from "./FooterConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports